import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { gettext } from 'utils/text';

const UploadWorkSubtitle = (props) => (
    <Fragment>
        {props.withSubtitle && (
            <p className="subtitle">
                {gettext(
                    'You can upload JPEG, PNG, GIF, PDF, MP3, OGG, AC3, MPEG, MP4, Flash video, ' +
                        'as well as the most common microsoft formats, such as WMA and WMV.',
                )}
            </p>
        )}
        <p className="subtitle">
            {gettext(
                'By submitting your contribution you warrant that you have the copyrights of the grant and ' +
                    'allowed to publish it on the Internet. Trafo reserves the right to remove contributions that are ' +
                    'inappropriate or contrary to laws and regulations. Contributions are basically visible to all ' +
                    'visitors, but you can change them to be private after upload.',
            )}
        </p>
    </Fragment>
);

UploadWorkSubtitle.propTypes = {
    withSubtitle: PropTypes.bool,
};

UploadWorkSubtitle.defaultProps = {
    withSubtitle: true,
};

export default UploadWorkSubtitle;



// WEBPACK FOOTER //
// ./src/components/arena/UploadWorkSubtitle.js